export const PLACE_ORDER_MARKET_MODE = {
  SPOT: 'spot',
  PERPETUAL: 'perpetual',
};

export const PLACE_ORDER_EXECUTION = {
  LIMIT: 'limit',
  MARKET: 'market',
};

export const PERPETUAL_MARGIN_MODE = {
  CROSS: 'cross',
  ISOLATED: 'isolated',
};

export const LEVERAGE_PRESETS = [1, 5, 25, 50, 75, 100];

export const QUANTITY_PERCENT_MARKS = [0, 25, 50, 75, 100];
